/* eslint-disable jsx-a11y/anchor-is-valid */
import { useNavigate } from "react-router-dom";
import { MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";

import { useState } from "react";
import SearchBar from "../../../components/SearchBar";
import CreateIncident from "../../../Modals/createIncident";

const TrustComplianceOverview = () => {
    const navigate = useNavigate();
    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    const [searchTerm, setSearchTerm] = useState("");

    const rows = [
        {
            id: "INC-001",
            title: "Payment Gateway Timeout Errors",
            service: "Payment Service",
            severity: "Critical",
            status: "Investigating",
            assignee: "John Smith",
            affected: "1,250",
            updated: "12/11/2025",
        },
        {
            id: "INC-002",
            title: "AI Recommendation Engine Degraded",
            service: "AI Engine",
            severity: "High",
            status: "Acknowledged",
            assignee: "Sarah Chen",
            affected: "3,400",
            updated: "12/11/2025",
        },
        {
            id: "INC-003",
            title: "Database Connection Pool Exhaustion",
            service: "Database",
            severity: "High",
            status: "Open",
            assignee: "",
            affected: "890",
            updated: "12/11/2025",
        },
    ];

    return (
        <>
            <div className="main_title d_flex">
                <h1>Trust & Compliance Overview</h1>
            </div>
            {/* ===== Quick Actions ===== */}

            {/* ======= Stats Overview ======= */}
            <div className="stats_boxes gap_m">

                {/* Active Policies */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            6
                            <p>Active Policies</p>
                        </h2>

                        <figure className="blue">
                            <DescriptionOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="rating_box">
                        <p className="green">Active</p>
                        <span>8 total policies</span>
                    </div>
                </a>

                {/* Active Certifications */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            5
                            <p>Active Certifications</p>
                        </h2>

                        <figure className="warning">
                            <WorkspacePremiumOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="rating_box">
                        <p className="orange">4 expiring</p>
                    </div>
                </a>

                {/* Open Incidents */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            1
                            <p>Open Incidents</p>
                        </h2>

                        <figure className="danger">
                            <ReportProblemOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="rating_box">
                        <p className="red">Needs attention</p>
                    </div>
                </a>

                {/* Pending Tasks */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            9
                            <p>Pending Tasks</p>
                        </h2>

                        <figure className="sucess">
                            <TaskAltOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="rating_box">
                        <p className="red">9 overdue</p>
                    </div>
                </a>

            </div>




            <div className="mt_20 compliance_layout ">

                <div className="incidents_grid">

                    {/* Recent Incidents */}
                    <div className="dashboard_card">
                        <div className="card_header">
                            <h4>Recent Incidents</h4>
                            <a className="view_all">View All</a>
                        </div>

                        <ul className="list">
                            <li>
                                <div className="left">
                                    <span className="dot high" />
                                    <div>
                                        <b>Potential Phishing Attack</b>
                                        <small>INC-2024-005 · 6/1/2024</small>
                                    </div>
                                </div>
                                <span className="badge investigating">Investigating</span>
                            </li>

                            <li>
                                <div className="left">
                                    <span className="dot medium" />
                                    <div>
                                        <b>Unauthorized Access Attempt</b>
                                        <small>INC-2024-001 · 5/15/2024</small>
                                    </div>
                                </div>
                                <span className="badge resolved">Resolved</span>
                            </li>

                            <li>
                                <div className="left">
                                    <span className="dot critical" />
                                    <div>
                                        <b>Third-Party Vendor Data Exposure</b>
                                        <small>INC-2024-003 · 3/10/2024</small>
                                    </div>
                                </div>
                                <span className="badge resolved">Resolved</span>
                            </li>
                        </ul>
                    </div>

                    {/* Top Risks */}
                    <div className="dashboard_card">
                        <div className="card_header">
                            <h4>Top Risks</h4>
                            <a className="view_all">View All</a>
                        </div>

                        <ul className="list">
                            <li>
                                <div className="left">
                                    <span className="dot critical" />
                                    <div>
                                        <b>Ransomware Attack</b>
                                        <small>Score: 15 · Security</small>
                                    </div>
                                </div>
                                <span className="badge critical">Critical</span>
                            </li>

                            <li>
                                <div className="left">
                                    <span className="dot high" />
                                    <div>
                                        <b>Third-Party Data Breach</b>
                                        <small>Score: 15 · Security</small>
                                    </div>
                                </div>
                                <span className="badge high">High</span>
                            </li>
                        </ul>
                    </div>

                    {/* Upcoming Tasks */}
                    <div className="dashboard_card">
                        <div className="card_header">
                            <h4>Upcoming Tasks</h4>
                            <a className="view_all">View All</a>
                        </div>

                        <ul className="list">
                            <li>
                                <div className="left">
                                    <input type="checkbox" />
                                    <div>
                                        <b>DSAR Process Automation</b>
                                        <small>6/15/2024 · Development Team</small>
                                    </div>
                                </div>
                               
                            </li>

                            <li>
                                <div className="left">
                                    <input type="checkbox" />
                                    <div>
                                        <b>Vendor Risk Assessment</b>
                                        <small>6/20/2024 · Lisa Parker</small>
                                    </div>
                                </div>
                                
                            </li>
                        </ul>
                    </div>

                    {/* Expiring Certifications */}
                    <div className="dashboard_card">
                        <div className="card_header">
                            <h4>Expiring Certifications</h4>
                            <a className="view_all">View All</a>
                        </div>

                        <ul className="list">
                            <li>
                                <div className="left">
                                    <span className="cert_icon" />
                                    <div>
                                        <b>PCI DSS Level 1</b>
                                        <small>PCI Security Standards Council</small>
                                    </div>
                                </div>
                                <span className="expiry red">-363 days</span>
                            </li>

                            <li>
                                <div className="left">
                                    <span className="cert_icon" />
                                    <div>
                                        <b>SOC 2 Type II</b>
                                        <small>AICPA</small>
                                    </div>
                                </div>
                                <span className="expiry orange">-268 days</span>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>


            <CreateIncident
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />
        </>
    );
};

export default TrustComplianceOverview;
